import type { CloudConnectionType } from "@octopusdeploy/octopus-server-client";

export const getKubernetesTargetDiscoveryCloudProviders: () => Array<CloudConnectionType> = () => ["Aws", "Azure"];
